"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Extremophiles = void 0;
const Tags_1 = require("../Tags");
const CardType_1 = require("../CardType");
const ResourceType_1 = require("../../ResourceType");
const SelectCard_1 = require("../../inputs/SelectCard");
const CardName_1 = require("../../CardName");
const CardRequirements_1 = require("../CardRequirements");
const CardRenderer_1 = require("../render/CardRenderer");
const CardRenderDynamicVictoryPoints_1 = require("../render/CardRenderDynamicVictoryPoints");
const Card_1 = require("../Card");
class Extremophiles extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.EXTREMOPHILES,
            cardType: CardType_1.CardType.ACTIVE,
            tags: [Tags_1.Tags.VENUS, Tags_1.Tags.MICROBE],
            cost: 3,
            resourceType: ResourceType_1.ResourceType.MICROBE,
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.tag(Tags_1.Tags.SCIENCE, 2)),
            metadata: {
                cardNumber: '224',
                description: 'Requires 2 Science tags.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.action('Add 1 microbe to ANY card.', (eb) => {
                        eb.empty().startAction.microbes(1).asterix();
                    }).br;
                    b.vpText('1 VP for every 3rd Microbe on this card.');
                }),
                victoryPoints: CardRenderDynamicVictoryPoints_1.CardRenderDynamicVictoryPoints.microbes(1, 3),
            },
        });
        this.resourceCount = 0;
    }
    ;
    play() {
        return undefined;
    }
    canAct() {
        return true;
    }
    getVictoryPoints() {
        return Math.floor(this.resourceCount / 3);
    }
    action(player) {
        const microbeCards = player.getResourceCards(ResourceType_1.ResourceType.MICROBE);
        if (microbeCards.length === 1) {
            player.addResourceTo(this, { log: true });
            return undefined;
        }
        return new SelectCard_1.SelectCard('Select card to add 1 microbe', 'Add microbe', microbeCards, (foundCards) => {
            player.addResourceTo(foundCards[0], { log: true });
            return undefined;
        });
    }
}
exports.Extremophiles = Extremophiles;
//# sourceMappingURL=Extremophiles.js.map